export const sources={};export const img={src:"__VITE_ASSET__8KByd7W0oH8zGe1MvrBFUw__",w:640,h:640};export default{sources:sources,img:img};